import React from 'react'

interface ContactInfoIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
  style?: React.CSSProperties
}

const ContactInfoIcon: React.FC<ContactInfoIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 24,
  alt = 'Contact info icon',
  style = {},
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
      style={style}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M22 1.25H2a.75.75 0 00-.75.75v20c0 .414.336.75.75.75h20a.75.75 0 00.75-.75V2a.75.75 0 00-.75-.75zM2 0a2 2 0 00-2 2v20a2 2 0 002 2h20a2 2 0 002-2V2a2 2 0 00-2-2H2z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M10.414 9.279a2.1 2.1 0 001.585.663 2.13 2.13 0 001.58-.658 2.13 2.13 0 00.66-1.58 2.13 2.13 0 00-.66-1.582l-.008-.008a2.09 2.09 0 00-1.572-.664 2.14 2.14 0 00-1.595.659 2.13 2.13 0 00-.658 1.58c0 .621.213 1.135.659 1.58l.009.01zm4.05-4.04A3.338 3.338 0 0011.998 4.2c-.97 0-1.8.346-2.478 1.025a3.378 3.378 0 00-1.025 2.464c0 .956.346 1.786 1.025 2.465a3.346 3.346 0 002.478 1.038c.955 0 1.786-.346 2.464-1.024a3.378 3.378 0 001.025-2.465c0-.955-.346-1.786-1.024-2.464zM5.176 14.843c-.077.347-.11.679-.141.996l-.003.031c-.016.312-.032.639-.032.966 0 .856.272 1.54.832 2.055.544.498 1.264.762 2.128.762h8.08c.864 0 1.584-.249 2.128-.762.544-.514.832-1.2.832-2.055l-.012-.323c-.008-.218-.015-.434-.036-.643a8.163 8.163 0 00-.128-1.027 6.658 6.658 0 00-.272-1.043 3.98 3.98 0 00-.432-.965 3.991 3.991 0 00-.656-.84 2.975 2.975 0 00-.944-.577 3.436 3.436 0 00-1.216-.218c-.176 0-.336.063-.656.265-.16.116-.352.233-.56.358l-.128.078a4.23 4.23 0 01-.88.389c-.368.109-.72.171-1.088.171-.352 0-.72-.062-1.088-.171-.352-.125-.656-.25-.88-.39-.256-.155-.48-.295-.688-.435-.32-.203-.48-.265-.656-.265-.432 0-.848.078-1.216.218a3.38 3.38 0 00-.944.576c-.24.234-.464.514-.656.84a4.707 4.707 0 00-.432.966c-.112.327-.192.67-.256 1.043zm1.77-1.384c-.153.273-.258.502-.315.693l-.007.027-.01.026a5.43 5.43 0 00-.206.849l-.005.03-.007.032c-.058.26-.085.519-.117.845v.002c-.016.303-.029.59-.029.873 0 .564.165.893.427 1.133.282.258.687.434 1.283.434h8.08c.614 0 1.004-.17 1.27-.421.265-.25.434-.588.44-1.12l-.012-.304v-.004a8.149 8.149 0 00-.03-.556l-.003-.033-.002-.034a6.945 6.945 0 00-.11-.868l-.001-.009a5.413 5.413 0 00-.223-.849l-.009-.026-.007-.027a2.731 2.731 0 00-.297-.661l-.007-.012-.007-.011c-.13-.223-.28-.41-.435-.563a1.734 1.734 0 00-.532-.319 2.15 2.15 0 00-.647-.133 2.844 2.844 0 00-.082.05 9.36 9.36 0 01-.589.376l-.022.014-.12.073c-.34.21-.728.37-1.134.508l-.023.008-.023.007a5.02 5.02 0 01-1.443.222c-.496 0-.985-.087-1.443-.223l-.031-.009-.03-.01c-.361-.128-.773-.288-1.12-.504-.253-.154-.49-.302-.714-.453a3.01 3.01 0 00-.097-.059c-.234.013-.452.06-.64.13-.196.08-.385.195-.553.335a2.751 2.751 0 00-.417.541z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default ContactInfoIcon
